// src/pages/RunpodActivityPage.jsx
import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import RunpodLoadActivity from '../components/RunpodLoadActivity';

export default function RunpodActivityPage() {
  const [loadPattern, setLoadPattern] = useState(null);
  const [loading, setLoading]         = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function load() {
      try {
        const snap = await getDoc(doc(db, 'config', 'cloud'));
        if (snap.exists()) setLoadPattern(snap.data().loadPattern || null);
      } catch (e) {
        console.error('Failed to load activity pattern:', e);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  return (
    <div className="fade-up">
      {/* Back button */}
      <button
        onClick={() => navigate('/cloud')}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: 6,
          fontFamily: "'JetBrains Mono', monospace", fontSize: 11,
          color: 'var(--sand-muted)', background: 'none', border: 'none',
          cursor: 'pointer', padding: 0, marginBottom: 24,
        }}
        onMouseEnter={e => e.currentTarget.style.color = 'var(--sand-amber)'}
        onMouseLeave={e => e.currentTarget.style.color = 'var(--sand-muted)'}
      >
        ← Back to Cloud options
      </button>

      <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 22, fontWeight: 700, color: 'var(--sand-text)', marginBottom: 8 }}>
        Runpod GPU Load Activity
      </h2>
      <p style={{ fontSize: 13, color: 'var(--sand-muted)', marginBottom: 24, lineHeight: 1.6 }}>
        Typical GPU availability patterns on Runpod — best times to launch your ComfyUI sessions.
        Based on historical usage data; actual availability varies.
      </p>

      {loading ? (
        <div style={{ padding: 40, textAlign: 'center', color: 'var(--sand-hint)', fontSize: 13, fontStyle: 'italic' }}>Loading…</div>
      ) : (
        <RunpodLoadActivity loadPattern={loadPattern} />
      )}
    </div>
  );
}
